import { render, staticRenderFns } from "./DeviceManagementModule.vue?vue&type=template&id=0b653141"
import script from "./DeviceManagementModule.vue?vue&type=script&lang=js"
export * from "./DeviceManagementModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports